<!-- HEADER categorias con / sin scroll automaticas -->
<header id="header" class="flex flex-col w-full font-poppins bg-white" [ngClass]="menuAbierto ? 'menuAbierto' : ' '">
	<div class="w-full flex bg-principal text-white z-40">
		<div class="px-10 w-full max-w-screen-xl"></div>
		<div [innerHTML]="processHTML(text)" class="w-max flex justify-center leading-4 p-2 sm:text-sm text-xs font-light uppercase text-white"></div>
		<div class="px-10 w-full max-w-screen-xl relative mx-auto h-auto md:h-8 flex flex-col sm:flex-row justify-end items-end">
			<div class="flex items-center gap-2 z-10">

				<a target="_blank" href="https://www.instagram.com/rednumberscoffee/"
					class="text-center justify-center rounded-full mx-auto "
					aria-label="Enlace a nuestra cuenta de Instagram">
					<img src="/assets/icons/instagram-footer.svg" alt="" class="w-8 h-auto mx-auto p-1"
						aria-hidden="true" focusable="false" />
				</a>

				<a target="_blank" href="https://www.facebook.com/profile.php?id=100093050805962"
					aria-label="Enlace a nuestro perfil de Facebook" class="icon-facebook text-white p-1.5"></a>
				<a target="_blank" href="https://www.tiktok.com/@rednumberscoffee" class="icon-tik-tok text-white p-1.5"
					aria-label="Enlace a nuestra cuenta de TikTok"></a>


				<!-- <a target="_blank" href="https://www.instagram.com/rednumberscoffee/" class="text-center justify-center rounded-full mx-auto ">
					<img src="/assets/icons/instagram-footer.svg" alt="Instagram" class="w-8 h-auto mx-auto p-1" />
				</a> -->
				<!-- <a target="_blank" aria-label="Abrir perfil de Facebook" href="https://www.facebook.com/profile.php?id=100093050805962">
					<span role="link" class="icon-facebook text-white p-1.5"></span>
				</a> -->
				<!-- <a target="_blank" href="https://www.tiktok.com/@rednumberscoffee">
					<button role="link"class="icon-tik-tok text-white p-1.5"></button>
				</a> -->

				<!-- <button class="icon-twitter-alt text-white p-1.5"></button> -->

				<!-- <a href="">
					<button class="icon-telegram text-white p-1.5"></button>
				</a> -->

			</div>
		</div>
	</div>
	<div
		class="z-40 bg-white relative flex-none w-full max-w-screen-xl flex flex-row items-center px-3 sm:px-4 text-info py-2 md:py-3 mx-auto justify-between md:justify-end h-20 md:h-24">
		<!-- <button (click)="hideMenu()" [routerLink]="'/'+id_store_current" aria-label="Home" class="hidden lg:block text-sm lg:text-base uppercase hover:text-principal-hover focus:text-principal-hover focus:outline-none"><span class="material-icons-outlined">home</span>{{'header.home' | translate}}</button> -->
		<!-- <button routerLink="/" class="block text-2xl lg:text-3xl material-icons-outlined hover:text-principal-hover focus:text-principal-hover focus:outline-none">location_on</button> -->

		<!-- logo -->
		<a (click)="hideMenu()" [routerLink]="'/' + id_store_current" aria-label="Red Numbers "
			class="transform block h-16 md:h-20 z-30 py-1 px-3 md:py-3 border-2 border-transparent focus-within:border-white focus-within:outline-none">
			<img [src]="!logo ? '/assets/images/rednumbers-logo.png' : logo" alt="{{ 'header.marca' | translate }}"
				class="h-full w-auto object-contain" />
		</a>
		<div class="flex-1 absolute md:relative w-full z-10">
			<nav *ngIf="headerType == '1'" class="flex flex-col flex-1 justify-center gap-x-4 w-full">
				<div class="absolute lg:relative left-0 right-0 top-20 lg:top-0 menu-container flex flex-wrap items-start mx-auto w-full px-4 z-30 bg-white justify-center text-center"
					[ngClass]="menuAbierto ? 'flex h-96 justify-center lg:justify-start overflow-y-auto' : 'hidden lg:flex'">
					<ul *ngIf="categories.length > 0 && false"
						class="w-full md:w-auto flex flex-col lg:flex-row p-4 md:p-0 gap-y-4 md:gap-x-8 lg:gap-x-4 xl:gap-x-8 md:items-center">
						<li *ngFor="let category of categories" class="relative md:pl-4">
							<button *ngIf="category.sub_categories.length === 0"
								(click)="redirectCtg(category.slug, category, false); hideMenu(); show = false"
								class="lg:whitespace-nowrap text-lghover:text-principal focus:text-principal focus:outline-none flex items-center uppercase">
								{{ category.name }}
							</button>
							<button *ngIf="category.sub_categories.length > 0" (click)="toggleCtg(category)"
								class="whitespace-nowrap group flex items-center w-full sm:justify-start text-lghover:text-principal focus:text-principal focus:outline-none uppercase">
								<span>{{ category.name }}</span>
								<span class="flex-none material-icons-outlined group-focus:text-principal-medio ml-1"
									[ngClass]="show ? 'text-principal-medio' : ''">expand_more</span>
							</button>
							<ul *ngIf="category.show && category.sub_categories.length > 0 && !isCollection(category.slug)"
								class="bg-white md:absolute left-0 flex flex-col gap-1 pt-2 pb-3 px-4 min-w-full"
								[ngClass]="show ? '' : ''">
								<li *ngFor="let item of category.sub_categories"
									class="flex w-full justify-center items-center cursor-pointer">
									<button (click)="redirectCtg(item.slug, category, true); hideMenu(); show = !show"
										class="whitespace-nowrap flex items-center w-full justify-start font-light hover:text-principal-hover focus:text-principal-hover focus:outline-none uppercase">
										{{ item.name }}
									</button>
								</li>
							</ul>
							<div *ngIf="categoryOpen.show && categoryOpen.sub_categories.length > 0 && category.id === categoryOpen.id && isCollection(categoryOpen.slug)"
								class="mt-2 sm:hidden">
								<div class="max-w-screen-xl px-0 pb-5 mx-auto">
									<ul class="flex flex-col md:flex-row gap-4">
										<li *ngFor="let item of categoryOpen.sub_categories" role="button"
											(click)="redirectCtg(item.slug, categoryOpen, true); hideMenu(); show = !show"
											class="group cursor-pointer w-auto h-20 relative overflow-hidden"
											[ngClass]="{ 'bg-moderna': item.slug === 'modern-collection', 'bg-nordica': item.slug === 'nordic-collection', 'bg-botanica': item.slug === 'botanical-collection' }">
											<div class="w-full h-full z-0 flex items-center md:text-center">
												<h2 class="md:self-end w-full uppercase px-6 py-3 z-10">{{ item.name }}
												</h2>
												<!-- <img class="absolute w-full h-full object-cover object-right z-0" *ngIf="item.image != null && item.image != ''" [src]="item.image"  [alt]="'banner category: ' + item.name" /> -->
												<img class="h-full object-cover object-top"
													src="assets/images/{{ item.slug }}.jpg"
													[alt]="'banner category: ' + item.name" />
											</div>
										</li>
									</ul>
								</div>
							</div>
						</li>
					</ul>
					<ul
						class="w-full md:w-auto lg:w-full flex flex-col lg:flex-row p-4 md:p-0 gap-y-2 md:gap-y-4 gap-x-4 lg:gap-x-6 items-center justify-evenly">
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('our-purpose'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-black hover:text-principal focus:text-principal focus:outline-none flex items-center capitalize">
								Our Purpose
							</button>
						</li>
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('all'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-black hover:text-principal focus:text-principal focus:outline-none flex items-center capitalize">
								Shop
							</button>
						</li>
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('brew-it'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-black hover:text-principal focus:text-principal focus:outline-none flex items-center capitalize">
								Brew It Right
							</button>
						</li>
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('contact-us'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-black hover:text-principal focus:text-principal focus:outline-none flex items-center capitalize">
								Contact Us
							</button>
						</li>
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('find-us'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-black hover:text-principal focus:text-principal focus:outline-none flex items-center capitalize">
								Find Us
							</button>
						</li>
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('my-subscriptions'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-black hover:text-principal focus:text-principal focus:outline-none flex items-center capitalize">
								My Subscriptions
							</button>
						</li>
						<li class="relative md:pl-4 lg:pl-0">
							<button (click)="redirectHeader('join-us'); hideMenu(); show = false"
								class="font-montserrat lg:whitespace-nowrap text-sm lg:text-xs xl:text-sm text-principal underline font-bold hover:text-principal-hover focus:text-principal-hover focus:outline-none flex items-center capitalize">
								Become An Affiliate
							</button>
						</li>
					</ul>
				</div>
				<div [ngClass]="categoryOpen.show && categoryOpen.sub_categories?.length > 0 && isCollection(categoryOpen.slug) ? '' : 'max-h-0'"
					class="relative hidden sm:flex">
					<div class="absolute left-0 top-0 w-full bg-white transition-all transform ease-in-out duration-700 overflow-hidden"
						[ngClass]="categoryOpen.show && categoryOpen.sub_categories?.length > 0 && isCollection(categoryOpen.slug) ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-96'">
						<ul class="flex flex-col md:flex-row gap-4 md:justify-center px-4 mx-auto">
							<li *ngFor="let item of categoryOpen.sub_categories" role="button"
								(click)="redirectCtg(item.slug, categoryOpen, true); hideMenu(); show = !show"
								class="group cursor-pointer w-72 h-64 relative overflow-hidden"
								[ngClass]="{ 'bg-moderna': item.slug === 'modern-collection', 'bg-nordica': item.slug === 'nordic-collection', 'bg-botanica': item.slug === 'botanical-collection' }">
								<div class="w-full h-full z-0 flex text-center">
									<h2 class="self-end w-full uppercase px-6 py-3 z-10">{{ item.name }}</h2>
									<!-- <img class="absolute w-full h-full object-cover object-right z-0" *ngIf="item.image != null && item.image != ''" [src]="item.image"  [alt]="'banner category: ' + item.name" /> -->
									<img class="absolute w-full h-full top-0 left-0 object-cover object-top z-0"
										src="assets/images/{{ item.slug }}.jpg"
										[alt]="'banner category: ' + item.name" />
								</div>
								<div class="absolute w-full h-full top-0 left-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-700 z-20"
									[ngClass]="{ 'bg-moderna': item.id === 'S2024g0207024124b', 'bg-nordica': item.id === 'J2024z0207024201D', 'bg-botanica': item.id === 'Q2024A0207024146D' }">
									<div class="text-sm leading-4 p-6 text-center">
										<h2 class="self-end w-full uppercase py-3 z-10">{{ item.name }}</h2>
										<div class="ocultarSegundo flex flex-col gap-2" [innerHtml]="item.description">
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>

		<!-- categorias CON scroll -->
		<nav *ngIf="headerType == '2'" class="flex-none lg:flex-1 overflow-hidden w-full h-full relative bg-blue">
			<!-- nav categorias -->
			<div class="overflow-y-auto flex justify-start lg:justify-center py-2 px-4">
				<ul
					class="transition h-full flex flex-row flex-nowrap lg:flex-wrap justify-start lg:justify-center align-center gap-2 items-center w-auto whitespace-nowrap">
					<ng-container *ngIf="categories.length > 0">
						<li *ngFor="let category of categories" class="whitespace-nowrap">
							<button (click)="redirectCtg(category.slug, isAuth)"
								class="rounded-xl px-2 lg:text-lg bg-principal-claro hover:bg-principal focus:bg-principal focus:outline-none">
								{{ category.name }}
							</button>
						</li>
					</ng-container>
				</ul>
			</div>
		</nav>
		<!-- nav icos mobile -->
		<ul class="flex sm:hidden flex-row items-center mb-4 p-3 gap-3 justify-around z-20 fixed bottom-0 inset-x-4 text-white rounded shadow-base sm:shadow-none"
			[ngClass]="menuAbierto ? 'bg-black bg-opacity-80' : 'bg-gris-oscuro '">
			<li>
				<button aria-label="Home" routerLink="/home"
					class="flex flex-col text-sm items-center focus:outline-none"
					[ngClass]="!isAuth ? ' hover:text-principal focus:text-principal ' : ' hover:text-wholesale-principal focus:text-wholesale-principal'">
					<span class="text-3xl material-icons-outlined">home</span>
					<span> {{ 'header.home' | translate }} </span>
				</button>
			</li>
			<li (click)="contactWhatsapp()">
				<button aria-label="Whatsapp"
					class="flex flex-col text-sm items-center focus:outline-none hover:text-principal focus:text-principal">
					<span class="text-3xl icon-whatsapp"></span>
					<span> whatsapp </span>
				</button>
			</li>
			<li class="flex items-center">
				<!--le elimino este comando para que muestre siempre el cart *ngIf="cartCount > 0" -->
				<!-- (click)="open()" -->
				<button routerLink="/{{ id_store_current }}/cart" aria-label="Shooping Cart"
					class="relative group flex flex-col text-sm items-center focus:outline-none"
					[ngClass]="!isAuth ? ' hover:text-principal focus:text-principal ' : ' hover:text-wholesale-principal focus:text-wholesale-principal'">
					<span>
						<span class="icon-carrito text-3xl"></span>
						<span class="cdk-visually-hidden"></span>
						<span
							class="absolute text-xs inline-flex w-5 h-5 items-center justify-center bg-principal rounded-full mt-3 text-white group-hover:bg-principal-hover group-focus:bg-principal-hover -right-1">{{
							cartCount }}</span>
					</span>
					<span> {{ 'header.mycart' | translate }} </span>
				</button>
			</li>
			<!--
            <li *ngIf="isAuth"><button href="/" class="flex flex-col text-sm items-center text-principal-hover hover:text-white focus:text-white focus:outline-none">
                <span class="text-3xl material-icons-outlined">store</span>
                <span> {{'header.retail' | translate}}  </span> 
                </button></li>
            <li *ngIf="isAuth"><button aria-label="My Account" routerLink="/home/wholesales/profile" class="flex flex-col text-sm items-center hover:text-wholesale-principal focus:text-wholesale-principal focus:outline-none">
                <span class="text-3xl material-icons-outlined">account_circle</span>
                <span> {{'header.account' | translate}} </span>
            </button></li>
            <li *ngIf="!isAuth"><button (click)="redirectwholesale()" class="flex flex-col text-sm items-center text-wholesale-principal hover:text-principal-hover focus:text-principal-hover focus:outline-none">
                <span class="text-3xl material-icons-outlined">store</span>
                <span> {{'header.wholesale' | translate}}  </span> 
            </button></li>
            -->
		</ul>
		<!-- HISTORIAS -->
		<!-- <div class="bg-white h-27 flex flex-row justify-between p-3">
                  <div> <div><img class="border-2 border-principal rounded-full p-0.5" src="assets/images/anillos.jpg" alt=""> </div> <p class="text-center historias">Anillos</p></div>
                  <div> <div><img class="border-2 border-principal rounded-full p-0.5" src="assets/images/brazaletes.jpg" alt=""> </div> <p class="text-center historias">Brazaletes</p></div>
                  <div> <div><img class="border-2 border-principal rounded-full p-0.5" src="assets/images/novedades.jpg" alt=""> </div> <p class="text-center historias">Novedades</p></div>
                  <div> <div><img class="border-2 border-principal rounded-full p-0.5" src="assets/images/materiales.png" alt=""> </div> <p class="text-center historias">Materiales</p></div>
                  <div> <div><img class="border-2 border-principal rounded-full p-0.5" src="assets/images/oferta.jpg" alt=""> </div> <p class="text-center historias">Oferta</p></div>
              </div> -->





			  



		<div class="flex flex-row items-center gap-2 z-30">
			<!-- nav icos escritorio -->
			<div class="hidden sm:flex items-center -mt-1">
				<!-- (click)="open()" -->
				<button routerLink="/{{ id_store_current }}/cart" aria-label="Shooping Cart"
					class="h-10 w-10 relative group flex items-center justify-center focus:outline-none"
					[ngClass]="!isAuth ? ' ' : ' hover:text-wholesale-principal focus:text-wholesale-principal'">
					<span class="icon-carrito text-xl group-hover:text-principal group-focus:text-principal"></span>
					<span class="cdk-visually-hidden"></span>
					<span
						class="absolute inline-flex w-4 h-4 items-center justify-center bg-principal rounded-full -mt-4 text-white group-hover:bg-principal-hover group-focus:bg-principal-hover right-1">
						<span class="w-3 h-3" style="font-size: 10px">{{ cartCount }}</span>
					</span>
				</button>
				<button routerLink="/{{ id_store_current }}/cart" class="text-principal pl-2 pr-2 whitespace-nowrap "
					style="font-size: 20px" *ngIf="cartTotal > 0">{{ cartTotal | currencyPersonalized }}</button>
				<!-- <p class="font-bold text-principal">{{ TotalCart | currencyPersonalized }}</p> -->

				<button *ngIf="false"
					class="h-10 w-10 relative group flex items-center justify-center focus:outline-none">
					<span class="icon-user text-xl group-hover:text-principal group-focus:text-principal"></span>
				</button>
				<!-- FAVORITOS -->
				<div *ngIf="false" class="h-10 w-10 relative group flex items-center justify-center focus:outline-none">
					<button class="h-10 w-10 relative group flex items-center justify-center focus:outline-none">
						<span
							class="icon-favoritos text-xl group-hover:text-principal group-focus:text-principal"></span>
						<span 
							class="absolute inline-flex w-4 h-4 items-center justify-center bg-principal rounded-full -mt-4 text-white group-hover:bg-principal-hover group-focus:bg-principal-hover right-1">
							<span class="w-3 h-3" style="font-size: 10px">{{ productsFavorites.length }}</span>
						</span>
					</button>
					<div
						class="z-30 absolute top-2 right-0 max-h-10 focus-within:max-h-96 w-12 focus-within:w-auto md:focus-within:w-72 focus-within:fixed md:focus-within:absolute focus-within:top-28 md:focus-within:top-8 focus-within:left-2 md:focus-within:left-auto focus-within:right-2 md:focus-within:right-0 opacity-0 focus-within:opacity-100 border flex flex-col">
						<!-- resultados instantaneos productsFavorites -->
						<div *ngIf="productsFavorites.length > 0"
							class="flex-1 flex flex-col w-full h-full bg-white overflow-x-hidden overflow-y-auto text-sm focus:outline-none"
							tabindex="0">
							<div *ngFor="let product of productsFavorites"
								class="relative flex justify-between items-center gap-2 border-b p-2 cursor-pointer"
								tabindex="0" (click)="redirectSlugFavorite(product)">
								<div class="w-16 h-16">
									<img class="max-w-full max-h-full object-contain" alt=""
										[src]="product.images?.length > 0 ? product.images[0].url : default_photo" />
								</div>
								<div class="flex flex-col">
									<h2>{{ product.nombre }}</h2>
									<p class="text-xs">{{ product.subtitle | descVariants | slice : 0 : 32 }}</p>
								</div>
								<span class="flex icon-cerrar text-xl text-principal-hover"
									(click)="removeFromFavorite(product)"></span>
							</div>
						</div>
						<div *ngIf="productsFavorites.length === 0"
							class="flex-1 flex flex-col w-full h-full bg-white overflow-x-hidden overflow-y-auto text-sm focus:outline-none"
							tabindex="0">
							<p class="text-center">No results</p>
						</div>
					</div>
				</div>
			</div>

			<!-- Buscador -->
			<div class="relative h-10 w-10 -mr-2">
				<span
					class="icon-buscar text-xl absolute left-1/2 -translate-x-1/2 top-1/2 transform -translate-y-1/2 pointer-events-none z-20"></span>
				<div
					class="absolute top-0 right-0 max-h-10 focus-within:max-h-96 w-12 focus-within:w-auto md:focus-within:w-72 focus-within:fixed md:focus-within:absolute focus-within:top-28 md:focus-within:top-0 focus-within:left-2 md:focus-within:left-auto focus-within:right-2 md:focus-within:right-0 opacity-0 focus-within:opacity-100 border flex flex-col">
					<input autocomplete="none" name="searchTerm" type="text" [(ngModel)]="searchTerm" (keyup)="search()"
						class="flex-none px-4 py-2 border-b focus:outline-none w-full" placeholder="Buscar" />
					<!-- resultados instantaneos buscador -->
					<div *ngIf="list.length > 0"
						class="flex-1 flex flex-col w-full h-full bg-white overflow-x-hidden overflow-y-auto text-sm focus:outline-none"
						tabindex="0">
						<div class="flex items-center justify-between border-b mx-2 py-2">
							<h2>Productos</h2>
							<a routerLink="/{{ id_store_current }}/search"
								class="text-xs hover:underline focus:underline focus:outline-none">Ver todo</a>
						</div>
						<!-- Producto 1 -->
						<div *ngFor="let product of list"
							class="flex items-center gap-2 border-b py-2 mx-2 cursor-pointer hover:bg-principal-claro focus:bg-principal-claro"
							tabindex="0" (click)="getSlug(product)">
							<div class="w-16 h-16">
								<img class="max-w-full max-h-full object-contain" alt=""
									[src]="product.variants[0]?.images?.length > 0 ? product.variants[0].images[0].url : default_photo" />
							</div>
							<div class="flex flex-col">
								<h2>{{ product.variants[0].name }}</h2>
								<p class="text-xs">{{ product.variants[0] | descVariants | slice : 0 : 32 }}</p>
							</div>
						</div>
						<!-- footer -->
						<div class="flex justify-end m-2">
							<a routerLink="/{{ id_store_current }}/search"
								class="text-xs hover:underline focus:underline focus:outline-none">Ver más
								resultados</a>
						</div>
					</div>
					<div *ngIf="list.length === 0 && searchReady"
						class="flex-1 flex flex-col w-full h-full bg-white overflow-x-hidden overflow-y-auto text-sm focus:outline-none"
						tabindex="0">
						<p class="text-center">No results</p>
					</div>
				</div>
			</div>

			<!-- burger -->
			<button *ngIf="headerType == '1'" id="burgerBtn" aria-label="Menu" (click)="abrirMenu()"
				class="relative lg:hidden flex flex-col gap-1.5 w-10 h-8 z-30 focus:outline-none hover:opacity-75 focus:opacity-75"
				[ngClass]="!isAuth ? '  ' : ' mr-10 md:mr-0'">
				<div class="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
					<span aria-hidden="true"
						class="block absolute h-0.5 w-5 bg-info transform transition-transform duration-500 ease-in-out"></span>
					<span aria-hidden="true"
						class="block absolute h-0.5 w-5 bg-info transform transition-opacity duration-500 ease-in-out"></span>
					<span aria-hidden="true"
						class="block absolute h-0.5 w-5 bg-info transform transition-transform duration-500 ease-in-out"></span>
				</div>
			</button>
		</div>
		<!-- para colocar mas de un icono
            <ul class="sm:flex sm:flex-row items-center bg-principal-hover sm:bg-white text-principal sm:m-0 sm:ml-2 lg:ml-3 sm:p-0 sm:gap-2 lg:gap-5 z-20 fixed sm:static bottom-0 m-4 p-3 inset-x-4 sm:inset-x-auto rounded shadow-base sm:shadow-none flex justify-around sm:justify-end gap-4 ">
            <li class="sm:hidden "><button aria-label="Home" routerLink="/home" class="flex items-center material-icons-outlined focus:outline-none " [ngClass]="!isAuth ? ' hover:text-principal-claro focus:text-principal-claro lg:hover:text-principal-medio lg:focus:text-principal-medio ' : ' hover:text-wholesale-principal focus:text-wholesale-principal' ">home</button></li>
            <li *ngIf="!isAuth " class="lg:hidden fixed sm:static top-2 right-2 "><button aria-label="Wholesale " (click)="redirectwholesale() " class="flex items-center material-icons-outlined text-wholesale-principal hover:text-principal-hover focus:text-principal-hover px-1 focus:outline-none ">lock</button></li>
            <li *ngIf="isAuth "><button aria-label="My Account " routerLink="/home/wholesales/profile " class="flex items-center material-icons-outlined hover:text-wholesale-principal focus:text-wholesale-principal focus:outline-none ">account_circle</button></li>
            <li *ngIf="!isAuth "><button routerLink="/ " class="material-icons-outlined ">location_on</button></li>
            <li class="sm:hidden "><button aria-label="how-works " routerLink="/how-works " class="flex items-center material-icons-outlined focus:outline-none " [ngClass]="!isAuth ? ' hover:text-principal-hover focus:text-principal-hover ' : ' hover:text-wholesale-principal focus:text-wholesale-principal' ">info</button></li>
            <li (click)="logout()" *ngIf="isAuth" class="fixed top-2 right-2 sm:static flex items-center"><button aria-label="Logout" class="material-icons-outlined hover:text-wholesale-principal focus:text-wholesale-principal focus:outline-none">logout</button></li>
            </ul>-->
	</div>

	<!-- categorias sin scroll -->
	<!-- nav categorias -->
	<!-- <nav *ngIf="headerType == '1'" class="relative w-full h-full">
        <ul class="menu absolute bg-white text-black left-0 top-0 transition h-0 sm:h-full sm:justify-center sm:static z-20 flex flex-col sm:flex-row align-center gap-2 sm:gap-4 sm:pb-2 sm:pt-2 items-center w-full overflow-hidden sm:overflow-visible pr-4 flex-wrap"
            [ngClass]="menuAbierto ? 'h-full pt-8 pb-2 justify-start overflow-y-auto' : 'pt-0 pb-0'">
            <ng-container *ngIf="categories.length > 0">
                <li *ngFor="let category of categories" class="whitespace-nowrap relative pl-4">
                    <button *ngIf="category.sub_categories.length === 0" (click)="redirectCtg(category.slug, category, false); hideMenu(); show = false" class="text-lghover:text-principal focus:text-principal focus:outline-none flex items-center"> {{category.name}} </button>
                    <button *ngIf="category.sub_categories.length > 0" (click)="toggleCtg(category)" class="group flex items-center w-full justify-center sm:justify-start text-lghover:text-principal focus:text-principal focus:outline-none "> 
                        <span>{{category.name}}</span>
                        <span class="flex-none material-icons-outlined group-focus:text-principal-medio ml-1" [ngClass]="show ? 'text-principal-medio' : ''">expand_more</span>
                    </button>
                    <ul *ngIf="category.show && category.sub_categories.length > 0" class="md:absolute left-0 flex flex-col gap-1 pt-2 pb-3 px-4 min-w-full" [ngClass]="show ? '' : ''">
                        <li *ngFor="let item of category.sub_categories" class="flex w-full cursor-pointer">
                            <div *ngIf="isCollection(item.slug)" class=" flex gap-4" (click)="redirectCtg(item.slug, category, true); hideMenu(); show = !show">
                                <img [src]="item.image" class="w-full"/>
                                <span class="text-xl">{{item.name}}</span>
                                <span class="text-lg">{{item.description || 'texto descriptivo'}}</span>
                            </div>
                            <button *ngIf="!isCollection(item.slug)" (click)="redirectCtg(item.slug, category, true); hideMenu(); show = !show" class="flex items-center w-full justify-center md:justify-start font-light hover:text-principal-hover focus:text-principal-hover focus:outline-none">
                                {{item.name}}
                            </button>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </ul>
       
    </nav> -->
	<nav class="fixed left-0 top-32 -translate-y-1/2 flex flex-col z-40 w-2/5">
		<div class="absolute left-0 flex flex-col pointer-events-none">
			<div *ngFor="let category of categories_float; let idx = index"
				class="pointer-events-auto w-full md:max-w-3xl h-32 md:h-40 flex md:items-stretch justify-start transform -translate-x-11/12 group hover:translate-x-0 focus-within:translate-x-0 ease-in-out duration-500 transition-transform">
				<button (click)="redirectCollection(category.slug)"
					class="w-11/12 flex-1 flex items-center text-white overflow-hidden bg-black" [ngClass]="{
						'from-moderna via-moderna': category.slug === 'ready-to-drink',
						'from-nordica via-nordica': category.slug === 'ground--beans',
						'from-botanica via-botanica': category.slug === 'k-cups'
					}">
					<div
						class="flex-2 py-6 pl-2 sm:pl-6 pr-0 sm:pr-1 m-0 flex flex-col w-6/12 md:w-7/12 lg:w-2/3 text-left items-start">
						<span class="uppercase text-xl sm:text-2xl font-extrabold font-dunbar">{{ category.name
							}}</span>
						<div class="ocultarPrimero text-xs hidden lg:block"
							*ngIf="category.description != '' && category.description != null"
							[innerHtml]="category.description"></div>
					</div>
					<div class="flex-1 relative block p-1 h-full w-full">
						<!-- <img class="h-full w-auto object-contain object-right z-10" [src]="'assets/images/' + category.slug + '-menucolection.png' "> -->
						<img class="absolute left-0 top-1 right-0 bottom-1 h-full w-full object-cover sm:object-contain lg:object-cover z-10"
							[alt]="category.slug" [src]="'assets/images/' + category.slug + '-menucolection.avif'" />
					</div>
				</button>
				<button
					class="bg-principal text-base overflow-hidden border border-black w-1/12 h-32 md:h-40 focus:outline-none text-white"
					[ngClass]="{
						'group-hover:bg-principal group-focus:bg-principal': category.slug === 'ready-to-drink',
						'group-hover:bg-principal group-focus:bg-principal lg:text-sm': category.slug === 'ground--beans',
						'group-hover:bg-principal group-focus:bg-principal': category.slug === 'k-cups'
					}">
					<span
						class="text-2xs sm:text-xs w-32 leading-3 p-1 pb-2.7 sm:pb-2.5 md:pb-3 lg:pb-0 flex items-center justify-center transform -rotate-90 -translate-x-12 md:-translate-x-12 xl:-translate-x-10 2xl:-translate-x-8 uppercase">{{
						category.name }}</span>
				</button>
			</div>
		</div>
	</nav>
</header>

<!-- whatsap button flotante -->
<button *ngIf="false" (click)="contactWhatsapp()" aria-label="whatsapp"
	class="hidden sm:flex items-center justify-center m-4 bg-whatsapp rounded-full focus:outline-none text-white hover:bg-success-hover focus:bg-success-hover fixed right-0 bottom-0 z-60">
	<span class="material-icons-outlined text-5xl p-1.5">whatsapp</span>
</button>